/**
 * @generated SignedSource<<5c5360ffd0a3607ba9fe389c0dcea296>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SortDirection = "ASC" | "DESC" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type listPaginationQuerySortFragment$data = {
  readonly isSorted: boolean;
  readonly isUnsorted: boolean;
  readonly orders: ReadonlyArray<{
    readonly direction: SortDirection;
    readonly isAscending: boolean;
    readonly isDescending: boolean;
    readonly property: string;
  }>;
  readonly " $fragmentType": "listPaginationQuerySortFragment";
};
export type listPaginationQuerySortFragment$key = {
  readonly " $data"?: listPaginationQuerySortFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"listPaginationQuerySortFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "listPaginationQuerySortFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSorted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnsorted",
      "storageKey": null
    },
    {
      "alias": "orders",
      "args": null,
      "concreteType": "Order",
      "kind": "LinkedField",
      "name": "toList",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "direction",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAscending",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDescending",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "property",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Sort",
  "abstractKey": null
};

(node as any).hash = "edd68d240cd7aa47635277461b3c9f69";

export default node;
